import { createSlice } from "@reduxjs/toolkit"

/** @typedef {"auth" | "register" | "reset_password"} ModalState */

const initialState = {
  showAuthDialog: false,
  authDialogModalState: "auth",
  authDialogExplanation: null,
  authDialogBandId: null,
  authDialogDefaultBandType: null,
}

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    openAuthDialog: (state, action) => {
      const payload = action.payload || {}
      state.showAuthDialog = true
      state.authDialogModalState = payload.modalState ?? "auth"
      state.authDialogExplanation = payload.explanation ?? null
      state.authDialogBandId = payload.bandId ?? null
      state.authDialogDefaultBandType = payload.defaultBandType ?? null
    },
    closeAuthDialog: (state) => {
      state.showAuthDialog = false
      state.authDialogModalState = "auth"
      state.authDialogExplanation = null
      state.authDialogBandId = null
      state.authDialogDefaultBandType = null
    },
  },
})

export const { openAuthDialog, closeAuthDialog } = navigationSlice.actions

export const selectShowAuthDialog = (state) => state.navigation.showAuthDialog
export const selectAuthDialogModalState = (state) =>
  state.navigation.authDialogModalState
export const selectAuthDialogExplanation = (state) =>
  state.navigation.authDialogExplanation
export const selectAuthDialogBandId = (state) =>
  state.navigation.authDialogBandId
export const selectAuthDialogDefaultBandType = (state) =>
  state.navigation.authDialogDefaultBandType

export default navigationSlice.reducer
